import { gql } from '@apollo/client';
import { CRM_AUTOMATION_FIELDS } from './queries';

export const CREATE_CRM_AUTOMATION = gql`
    mutation CreateCrmAutomation($input: CreateCrmAutomationInput!) {
        createCrmAutomation(input: $input) {
            ${CRM_AUTOMATION_FIELDS}
        }
    }
`;

export const UPDATE_CRM_AUTOMATION = gql`
    mutation UpdateCrmAutomation($input: UpdateCrmAutomationInput!) {
        updateCrmAutomation(input: $input) {
            ${CRM_AUTOMATION_FIELDS}
        }
    }
`;

export const DELETE_CRM_AUTOMATION = gql`
    mutation DeleteCrmAutomation($id: String!) {
        deleteCrmAutomation(id: $id) {
            _id
            name
        }
    }
`;

export const DUPLICATE_CRM_AUTOMATION = gql`
    mutation DuplicateCrmAutomation($input: DuplicateCrmAutomationInput!) {
        duplicateCrmAutomation(input: $input) {
            ${CRM_AUTOMATION_FIELDS}
        }
    }
`;

export const TEST_CRM_AUTOMATION = gql`
    mutation TestCrmAutomation($input: TestCrmAutomationInput!) {
        testCrmAutomation(input: $input) {
            runId
            mode
            scheduled
            message
            steps {
                stepIndex
                stepType
                outcome
                reason
            }
        }
    }
`;

/* manual "add to automation" — force-enrol a business/contact, run the steps */
export const ENROL_CRM_IN_AUTOMATION = gql`
    mutation EnrolCrmInAutomation($input: EnrolCrmInAutomationInput!) {
        enrolCrmInAutomation(input: $input) {
            runId
            alreadyEnrolled
        }
    }
`;
